import config from './config'
import { testTablet } from '../test'
import { getIpInformation } from './network'
import { getLocalIpPrefix, getLocalIpAddress } from './persistence'

const getEnvironmentConfig = async () => {
	console.warn('Running on laptop, thus returning mock config')
	return testTablet

	// IP addresses
	const ipInformation = await getIpInformation()
	const local_ip = ipInformation.ip ?? 'unknown'

	// Node Server Info
	const server_host = await config.server.getHost()
	const fridge_host = config.fridge.host

	// Networking
	const IP_PREFIX = getLocalIpPrefix()
	const IP_ADDRESS = getLocalIpAddress()

	// return {
	// 	esper_id,
	// 	serial_number,
	// 	local_ip,
	// 	fridge_host,
	// 	server_host,
	// 	LOGDNA_LOG_LEVEL,
	// 	IP_PREFIX,
	// 	IP_ADDRESS,
	// }
}

// @ts-ignore
window.getEnvironmentConfig = getEnvironmentConfig

export default getEnvironmentConfig
